export default __webpack_public_path__ + "static/media/linkedin.8861cb0e.svg";